export const ASSET_CATEGORIES = {
  HOME_BANNER: "HOME_BANNER",
};

export const NOTICE_CATEGORIES = {
  PRESS_RELEASE: "PRESS_RELEASE",
  PROCUREMENT: "PROCUREMENT",
  HR: "HR",
  OTHERS: "OTHERS",
};

export const NOTICE_CATEGORY_LABELS = {
  PRESS_RELEASE: "Press release",
  PROCUREMENT: "Procurement",
  HR: "HR",
  OTHERS: "Others",
};

export const NOTICE_CATEGORY_OPTIONS = [
  {
    label: "Press release",
    value: NOTICE_CATEGORIES.PRESS_RELEASE,
  },
  {
    label: "Procurement",
    value: NOTICE_CATEGORIES.PROCUREMENT,
  },
  {
    label: "HR",
    value: NOTICE_CATEGORIES.HR,
  },
  {
    label: "Others",
    value: NOTICE_CATEGORIES.OTHERS,
  },
];

export const PROJECT_CATEGORIES = [
  {
    label: "Detailed Engineering Study",
    value: "DETAILED_ENGINEERING_STUDY",
  },
  {
    label: "Environmental and Social Study",
    value: "ENVIRONMENTAL_AND_SOCIAL_STUDY",
  },
  {
    label: "Substation /  Transmission Line",
    value: "SUBSTATION_TRANSMISSION_LINE",
  },
  {
    label: "Grid Access",
    value: "GRID_ACCESS",
  },
  {
    label: "NEC Accomplishments - Technology",
    value: "NEC_ACCOMPLISHMENTS_TECHNOLOGY",
  },
  {
    label: "NEC Capabilities / Software Assets",
    value: "NEC_CAPABILITIES_SOFTWARE_ASSETS",
  },
  {
    label: "Others",
    value: "OTHERS",
  },
];

export const PROJECT_CATEGORIES_MAP = {
  DETAILED_ENGINEERING_STUDY: "Detailed Engineering Study",
  ENVIRONMENTAL_AND_SOCIAL_STUDY: "Environmental and Social Study",
  SUBSTATION_TRANSMISSION_LINE: "Substation /  Transmission Line",
  GRID_ACCESS: "Grid Access",
  NEC_ACCOMPLISHMENTS_TECHNOLOGY: "NEC Accomplishments - Technology",
  NEC_CAPABILITIES_SOFTWARE_ASSETS: "NEC Capabilities / Software Assets",
  OTHERS: "Others",
};

export const PROJECT_STATUSES = {
  PENDING: "PENDING",
  ONGOING: "ONGOING",
  COMPLETED: "COMPLETED",
  OTHERS: "OTHERS",
};

export const PROJECT_STATUS_OPTIONS = [
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Ongoing",
    value: "ONGOING",
  },
  {
    label: "Completed",
    value: "COMPLETED",
  },
  {
    label: "Others",
    value: "OTHERS",
  },
];

export const PROJECT_STATUS_LABELS = {
  PENDING: "Pending",
  ONGOING: "Ongoing",
  COMPLETED: "Completed",
  OTHERS: "Others",
};
